<template>
  <v-dialog v-model="show" max-width="500px" scrollable>
    <v-card>
      <v-card-title class="headline">Change Request Status</v-card-title>

      <v-card-text
        >Are you sure you want to change the status of this
        request?</v-card-text
      >

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="show = false">Cancel</v-btn>

        <v-btn color="red" text @click="acceptRequest()">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mdiClose } from '@mdi/js'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: this.value,
      loading: false,
      close: mdiClose
    }
  },

  methods: {
    acceptRequest() {
      this.show = false
      this.$emit('verify')
    }
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)
    }
  }
}
</script>
